import gql from 'graphql-tag';
import {
  callNgReasonFragment,
  contactNgReasonFragment,
  receptionNgReasonFragment,
  telStatusFragment,
} from '../../fragments';

export default gql`
  fragment telStatusChangeActivityFragment on TelStatusChangeActivity {
    telStatus
    telStatusText
    clientTelStatus {
      ...telStatusFragment
    }
    callNgReason {
      ...callNgReasonFragment
    }
    receptionNgReason {
      ...receptionNgReasonFragment
    }
    contactNgReason {
      ...contactNgReasonFragment
    }
  }
  ${telStatusFragment}
  ${callNgReasonFragment}
  ${receptionNgReasonFragment}
  ${contactNgReasonFragment}
`;
